import React, {
  Dispatch,
  useState,
  useMemo,
  useContext,
  ReactNode,
  SetStateAction,
  useRef,
} from "react";

interface IProps {
  children: ReactNode;
}

type IConfigModal = {
  visible: boolean;
  header: ReactNode;
  content: ReactNode;
  showBtnAccept: boolean;
  withClass?: string;
  titleOnAccept?: string;
  showBtnDecline?: boolean;
  titleOnDecline?: string;
  onAccept?: (props?: any) => void;
  onDecline?: (pros?: any) => void;
};

type IContext = {
  show: IConfigModal;
  setShow: Dispatch<SetStateAction<IConfigModal>>;
  modalRef: React.RefObject<HTMLDivElement | null>;
};

export const ModalContext = React.createContext<IContext>({} as IContext);
export const useModalContext = () => useContext<IContext>(ModalContext);

const ModalProvider = ({ children }: IProps) => {
  const modalRef = useRef<HTMLDivElement>(null);
  const [show, setShow] = useState<IConfigModal>({
    header: <></>,
    content: <></>,
    visible: false,
    showBtnAccept: false,
    showBtnDecline: false,
  });
  const context: IContext = useMemo(
    () => ({
      show,
      setShow,
      modalRef,
    }),
    [show],
  );
  return (
    <ModalContext.Provider value={context}>{children}</ModalContext.Provider>
  );
};

export default ModalProvider;
